export var HOME_TARIFF_CONNECT_LONG_FORM = 'HomeTariffConnectLongForm';
export var HOME_TARIFF_CALLBACK_LONG_FORM = 'HomeTariffCallbackLongForm';
export var CONVERGENT_CONNECT_UP_FORM = 'ConvergentConnectUpForm';
export var CONVERGENT_TARIFF_CONNECT = 'ConvergentTariffConnect';